/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, shape, string, arrayOf, func,
} from 'prop-types';
import { Link } from 'react-router-dom';
import { Grid, withStyles } from '@material-ui/core';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trackEvent as track } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getFeatureFlags, getCurrentBrandId } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getOperatingSystem } from '../../../../../state/ducks/App/ducks/Config/Config-Helpers';
import { determineChatlink } from '../../../MultiBrandChatController/Global_chat_helpers';
import triggerPopChatEvent from '../../../MultiBrandChatController/AigoChatWidgetWrapperV2/popOpenChat';

const styles = () => ({
    title: {
        marginTop: '10px',
    },
    container: {
        margin: '25px auto 10px',
        maxWidth: '80%',
    },
    linkContainer: {
        flex: '19%',
        padding: '7px',
        display: 'flex',
        flexDirection: 'column',
    },
    linkImg: {
        maxWidth: '100%',
    },
    link: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
    },
});

const LinkBlock = ({
    classes, data, trackEvent,
}) => {
    const {
        entries = [], font_color = {}, font_size = '', image_width = '', image_height = '',
    } = data;
    const operatingSystem = getOperatingSystem().toLowerCase();
    const currentBrand = useSelector((state) => getCurrentBrandId(state));
    const customerData = useSelector((state) => state?.member);
    const featureFlags = useSelector((state) => getFeatureFlags(state));
    const isMobileChatEnabled = ((featureFlags['is-gbm-in-pwa-enabled'] && operatingSystem === 'android') || (featureFlags['is-abc-in-pwa-enabled'] && operatingSystem === 'ios'));

    const desktopPopChat = () => {
        if (operatingSystem !== 'android' && operatingSystem !== 'ios') {
            triggerPopChatEvent({});
        }
    };
    const renderImage = (item) => (
        <img
            style={{
                width: image_width,
                height: image_height,
            }}
            src={item.image?.url}
            alt={item.link?.title}
            className={classes.linkImg}
        />
    );

    // scroll down Faq section
    const scrollDownToFaqSection = () => {
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            if (document.getElementById('faqContainer')) {
                const faqSection = document.getElementById('faqContainer');
                faqSection.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };

    // expose the phone number and  take down call us section
    const scrollDownToCallUs = () => {
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            if (document.getElementById('callUs')) {
                const callUsSection = document.getElementById('callUs');
                callUsSection.scrollIntoView({ behavior: 'smooth' });
                callUsSection.click();
            }
        }
    };
    const handleOnAction = (value) => {
        // covert the string into lower case and removing the spaces
        switch (value.toLowerCase().split(' ').join('')) {
            case 'issuewithyourorder':
                return scrollDownToFaqSection();
            case 'contactusbyphone':
                return scrollDownToCallUs();
            default: return null;
        }
    };

    const renderNonChatContent = (item) => (item.link?.href ? (
        <Link
            to={item.link.href}
            className={classes.link}
            onClick={() => {
                trackEvent({
                    eventCategory: item?.tracking_event_category || '',
                    eventAction: item?.tracking_event_action || '',
                    eventLabel: item?.tracking_event_label || '',
                });
            }}
            style={{
                color: font_color?.color,
                fontSize: `${font_size}em`,
            }}
        >
            {renderImage(item)}
            <span className={classes.title}>{item.link?.title}</span>
        </Link>
    )
        : (
            <span
                className={classes.link}
                role="presentation"
                onClick={() => handleOnAction(item.link?.title)}
            >
                {renderImage(item)} <span className={classes.title}>{item.link?.title}</span>
            </span>
        ));

    return (
        <Grid container className={classes.container}>
            {entries.map((item) => (
                <div key={item?.link?.title} className={classes.linkContainer}>
                    {
                        item.link?.title && item.link.title.toLowerCase()?.includes('chat')
                            ? (featureFlags['is-cs-page-chat-enabled'] && (!['ios', 'android'].includes(operatingSystem) || isMobileChatEnabled))
                            && (
                                <a
                                    href={determineChatlink(operatingSystem, currentBrand, featureFlags, customerData) || null}
                                    className={classes.link}
                                    style={{
                                        color: font_color?.color,
                                        fontSize: `${font_size}em`,
                                    }}
                                >
                                    <div
                                        aria-hidden="true"
                                        onClick={() => {
                                            trackEvent({
                                                eventCategory: item?.tracking_event_category || '',
                                                eventAction: item?.tracking_event_action || '',
                                                eventLabel: item?.tracking_event_label || '',
                                            });
                                            desktopPopChat();
                                        }}
                                    >
                                        {renderImage(item)}
                                    </div>
                                    <span className={classes.title}>{item.link?.title}</span>
                                </a>
                            )
                            : renderNonChatContent(item)
                    }
                </div>
            ))}
        </Grid>
    );
};

LinkBlock.propTypes = {
    classes: object.isRequired,
    trackEvent: func.isRequired,
    data: shape({
        image_entries: arrayOf(
            shape({
                image: shape({
                    url: string,
                }),
                link: shape({
                    href: string,
                    title: string,
                }),
            }),
        ),
    }),
};
LinkBlock.defaultProps = {
    data: {},
};
const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
});
export default connect(
    null,
    mapDispatchToProps,
)(withStyles(styles)(LinkBlock));
